import { EventSigHashes, FunctionSelectors } from '@lukso/lsp-smart-contracts'
import { AbiInput } from 'web3-utils'

import componentSelectorsJson from '@/transactionConfirmationSelectors/componentSelectors'
import { keyManagerABI } from '@/shared/abis/keyManagerABI'
import { upEventsABI } from '@/shared/abis/upEventsABI'
import { setDataABI } from '@/shared/abis/setDataABI'
import { getDataABI } from '@/shared/abis/getDataABI'
import { universalProfileABI } from '@/shared/abis/universalProfileABI'
import { TransactionComponent } from '@/shared/models/Transaction'
import { ABI_TYPES } from '@/shared/models/Network'
import { assertArray, assertString } from '@/shared/validators'
import { upEventsABI as upEventsABI_v_0_12_1 } from '@/shared/abis/v0.12.1/upEventsABI'

type SmartContractConfig = {
  kmExecuteRelayCallHex: string
  kmExecuteRelayCallParameters: AbiInput[]
  kmExecuteHex: string
  kmExecuteParameters: AbiInput[]
  upExecuteHex: string
  upExecuteParameters: AbiInput[]
  upExecuteBatchHex: string
  upExecuteBatchParameters: AbiInput[]
  contractCreatedSignature: string
  componentSelectors: TransactionComponent[]
  abis: {
    [K in ABI_TYPES]: any[]
  }
  getDataKey: string
  lsp7Selector: string
  lsp8Selector: string
  setDataHex: string
  setDataBatchHex: string
}

const kmExecuteRelayCall = Object.entries(
  FunctionSelectors.LSP6KeyManager
).find(([, { name }]) => name === 'executeRelayCall')

const kmExecute = Object.entries(FunctionSelectors.LSP6KeyManager).find(
  ([, { name }]) => name === 'execute'
)
const upExecute = Object.entries(FunctionSelectors.LSP0ERC725Account).find(
  ([, { name }]) => name === 'execute'
)
const upExecuteBatch = Object.entries(FunctionSelectors.LSP0ERC725Account).find(
  ([, { name }]) => name === 'executeBatch'
)
const setData = Object.entries(FunctionSelectors.LSP0ERC725Account).find(
  ([, { name }]) => name === 'setData'
)
const setDataBatch = Object.entries(FunctionSelectors.LSP0ERC725Account).find(
  ([, { name }]) => name === 'setDataBatch'
)

const kmExecuteRelayCallHex = kmExecuteRelayCall?.[0]
assertString(kmExecuteRelayCallHex)
const kmExecuteRelayCallParameters = kmExecuteRelayCall?.[1]?.inputs
assertArray(kmExecuteRelayCallParameters)

const kmExecuteHex = kmExecute?.[0]
assertString(kmExecuteHex)
const kmExecuteParameters = kmExecute?.[1]?.inputs
assertArray(kmExecuteParameters)

const upExecuteBatchHex = upExecuteBatch?.[0]
assertString(upExecuteBatchHex)
const upExecuteBatchParameters = upExecuteBatch?.[1]?.inputs
assertArray(upExecuteBatchParameters)

const upExecuteHex = upExecute?.[0]
assertString(upExecuteHex)
const upExecuteParameters = upExecute?.[1]?.inputs
assertArray(upExecuteParameters)

const setDataHex = setData?.[0]
assertString(setDataHex)
const setDataBatchHex = setDataBatch?.[0]
assertString(setDataBatchHex)

const contractCreatedSignature = Object.entries(
  EventSigHashes.LSP0ERC725Account
).find(([, value]) => value.name === 'ContractCreated')?.[0]
assertString(contractCreatedSignature)

const lsp7Selector = Object.entries(FunctionSelectors.LSP7DigitalAsset).find(
  ([, { name }]) => name === 'transfer'
)?.[0]
assertString(lsp7Selector)

const lsp8Selector = Object.entries(
  FunctionSelectors.LSP8IdentifiableDigitalAsset
).find(([, { name }]) => name === 'transfer')?.[0]
assertString(lsp8Selector)

export const SMART_CONTRACT_CONFIG: SmartContractConfig = {
  kmExecuteRelayCallHex,
  kmExecuteRelayCallParameters,
  kmExecuteHex,
  kmExecuteParameters,
  upExecuteHex,
  upExecuteParameters,
  upExecuteBatchHex,
  upExecuteBatchParameters,
  setDataHex,
  setDataBatchHex,
  contractCreatedSignature,
  lsp7Selector, // '0x760d9bba',
  lsp8Selector, // '0x511b6952',
  componentSelectors: componentSelectorsJson,
  abis: {
    KEY_MANAGER: keyManagerABI,
    SET_DATA: setDataABI,
    GET_DATA: getDataABI,
    UNIVERSAL_PROFILE: universalProfileABI,
    UP_EVENTS: upEventsABI,
    UP_EVENTS_0_12_1: upEventsABI_v_0_12_1,
  },
  getDataKey: 'dataKey',
}
